var render = function render(){var _vm=this,_c=_vm._self._c;return _c('s-basic-slice',_vm._b({staticClass:"root"},'s-basic-slice',_vm.$attrs,false),[_c('div',_vm._b({ref:"widgetWrapper",staticClass:"trustpilot-widget"},'div',_vm.widgetOptions,false),[_c('a',{attrs:{"href":_vm.externalLink,"target":"_blank","rel":"noopener"}},[_vm._v("Trustpilot")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }